<template>
    <div>
        <div class="toggle_wrap">
            <h3>{{ user.company }}</h3>
            <button class="hamburger-toggle" @click="showDashboardMenu = !showDashboardMenu">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
        </div>
        <div v-if="showDashboardMenu" class="dashboard_menu" @click="toggleNavs(windowWidth)">
            <ul class="side-links" v-if="menuType == 'super_admin' || userType == 'administrative'">
                <sidebar-item :link="{name: 'View Quote Submissions', icon: false, path: '/projects'}"/>
                <sidebar-item :link="{name: 'Document Lookup', icon: false, path: '/document-lookup/'}"/>
                <template v-if="user.role != 'approver'">
                    <sidebar-item :link="{name: 'Manage Registrations', icon: false, path: '/registrations'}"/>
                    <sidebar-item :link="{name: 'Manage Roles', icon: false, path: '/roles'}"/>
                    <sidebar-item v-if="canUse('users')" :link="{name: 'Manage Users', icon: false, path: '/users'}"/>
                    <sidebar-item v-if="user.role=='super_admin' || user.role.includes('administrator') || user.role.includes('ses-view')" :link="{name: 'Manage Static Tables', icon: false, path: '/static-tables'}"/>
                    <sidebar-item v-if="user.role=='super_admin' || user.role.includes('administrator') || user.role.includes('ses-view')" :link="{name: 'Manage Constants', icon: false, path: '/constants'}"/>
                    <sidebar-item v-if="user.role=='super_admin' || user.role.includes('administrator')" :link="{name: 'Manage Spare Parts', icon: false, path: '/manage-spare-parts'}"/>
                    <sidebar-item v-if="!user.role.includes('ses-view')" :link="{name: 'Follow Up Emails', icon: false, path: '/follow-up-emails'}"/>
                    <sidebar-item v-if="user.role=='super_admin' || user.role.includes('ses-view') || user.role.includes('administrator')" :link="{name: 'Survey Summaries', icon: false, path: '/survey-summaries'}"/>
                    <sidebar-item v-if="menuType == 'super_admin'" :link="{name: 'Wordpress Dashboard', icon: false, path: '/admin/users'}"/>
                    <sidebar-item v-if="user.role=='super_admin' || user.role.includes('administrator')" :link="{name: 'Settings', icon: false, path: '/settings'}"/>
                    <sidebar-item v-if="!user.role.includes('ses-view')" :link="{name: 'Manage Profile' , icon: false, xtra: 'ni ni-badge', path: '/profile'}"/>
                    <sidebar-item :link="{name: 'Inquiries', icon: false, path: '/inquiries'}"/>
                    <sidebar-item :link="{name: 'Manage Careers', icon: false, path: '/careers'}"/>
                    <sidebar-item :link="{name: 'Manage Item Lead Time', icon: false, path: '/item-leads'}"/>
                    <sidebar-item v-if="showHyperionPriceList" :link="{name: 'Hyperion Price Lists'     , icon: false, xtra: 'ni ni-support-16', path: '/hyperion-price-lists'}"/>
                </template>
            </ul>
            <ul class="side-links" v-else-if="menuType == 'project-manager'">
                <sidebar-item :link="{name: 'Projects', icon: false, path: '/projects'}"/>
                <sidebar-item :link="{name: 'Planning', icon: false, path: '/planning'}"/>
                <sidebar-item :link="{name: 'Drawings', icon: false, path: '/drawings'}"/>
                <sidebar-item v-if="!user.role.includes('ses-view')" :link="{name: 'Manage Profile' , icon: false, xtra: 'ni ni-badge', path: '/profile'}"/>
                <sidebar-item :link="{name: 'Document Lookup', icon: false, path: '/document-lookup/'}"/>
                <sidebar-item v-if="showHyperionPriceList" :link="{name: 'Hyperion Price Lists'     , icon: false, path: '/hyperion-price-lists'}"/>
            </ul>
            <ul class="side-links" v-else>
                <sidebar-item :link="{name: 'Main'                  , icon: false, xtra: 'ni ni-app', path: '/dashboard'}"/>
                <sidebar-item :link="{name: 'My Projects'           , icon: false, xtra: 'ni ni-bullet-list-67', path: '/projects'}" v-if="canUse('project_view') || user.role == 'Field'"/>
                <sidebar-item :link="{name: 'Sub Projects'          , icon: false, xtra: 'ni ni-bullet-list-67', path: '/subprojects'}" v-if="canUse('subproject_view')"/>
                <sidebar-item :link="{name: 'Planning', icon: false, path: '/planning'}" v-if="user.role=='super-user'"/>
                <sidebar-item :link="{name: 'Document Lookup'        , icon: false, path: '/document-lookup/'}"/>
                <sidebar-item :link="{name: 'Survey Summaries'      , icon: false, path: '/survey-summaries'}"  v-if="user.role=='super-user'"/>
                <sidebar-item :link="{name: 'My Tickets'            , icon: false, xtra: 'ni ni-bullet-list-67', path: '/tickets'}"/>
                <sidebar-item v-if="user.role!='Field'" :link="{name: 'Manage Profile'        , icon: false, xtra: 'ni ni-badge', path: '/profile'}"/>
                <sidebar-item :link="{name: 'Dashboard Support'     , icon: false, xtra: 'ni ni-support-16', path: '/dash-support'}"/>
                <sidebar-item v-if="showHyperionPriceList" :link="{name: 'Hyperion Price Lists'     , icon: false, xtra: 'ni ni-support-16', path: '/hyperion-price-lists'}"/>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            user: false,
            menuType: null,
            userType: null,
            showDashboardMenu: true,
            windowWidth: window.innerWidth,
            showHyperionPriceList: false
        }
    },
    mounted() {
        window.addEventListener('resize', this.onWindowResize)
        this.toggleNavs(this.windowWidth)
    },
    watch: {
        windowWidth(newWidth) {
            this.toggleNavs(newWidth)
        }
    },
    methods: {
        canUse(f) {
            if ( !this.user.functions ) return false;
            return this.user.functions.includes(f);
        },
        onWindowResize() {
            this.windowWidth = window.innerWidth
        },
        toggleNavs(width) {
            this.showDashboardMenu = false
            this.hideSubNavs()

            if(width >= 992) {
                this.showDashboardMenu = true
            }
        },
        hideSubNavs() {
            let sub_navs = document.getElementsByClassName('sub-nav')
            for(let x = 0; x < sub_navs.length; x++) {
                sub_navs[x].setAttribute('style', '')
            }
        }
    },
    beforeMount() {
        this.user = JSON.parse(localStorage.getItem('user'))
        this.menuType = this.user.role
        this.userType = this.user.type
        this.showHyperionPriceList = this.user.hyperion_price_list
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize)
    }
}
</script>
